module.exports = __webpack_public_path__ + "img/bank.95f41fde.svg";